import { createRoot } from 'react-dom/client';
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container as never);

root.render(<App />);

// Si un chunk con hash ya no existe en el servidor (deploy nuevo mientras
// la pestaña seguía abierta), recargamos una vez en vez de dejar pantalla en blanco.
window.addEventListener('vite:preloadError', () => {
  window.location.reload();
});
